import { defineMessages } from 'react-intl-next';

export const dropPlaceholderMessages = defineMessages({
	dropPlaceholderLabel: {
		id: 'fabric.editor.dropPlaceholderLabel',
		defaultMessage: 'Document',
		description: 'document label for an media icon',
	},
});
